import { Paa } from './paa.types';
import { Traceability } from './task-responses.types';
import { TaskDetails } from './task-responses.types';

export interface Tasks {
  tenantId: string;
  tasks: Task[];
  candidateGroup: string;
  status: string;
}

export enum TasksStatus {
  BROUILLON = 'BROUILLON',
  EN_TRAITEMENT = 'EN_TRAITEMENT',
  VALIDE = 'VALIDE',
  PUBLIEE = 'PUBLIE',
}

export interface FlowableProcess {
  processInstanceId: string;
  processDefinitionId: string;
  taskId: string;
  status: string;
}

export interface Task {
  taskId: string;
  taskName: string;
  taskDefinitionKey: string;
  assignee: string;
  processInstanceId: string;
  processDefinitionId: string;
  candidateGroup: string;
  traceability: Traceability;
  id: string;
  version: number;
  newStatus: string | null;
  validate: boolean | null;
  status: string | null;
  isUpdatable: boolean;
  isPublishable: boolean;
}

export interface PaaTaskDetails extends TaskDetails {
  paa: Paa;
}
